<template>
  <div>
    <h1>TEST</h1>
  </div>
</template>

<script>
export default {
  name: 'Test',
}
</script>

<style scoped lang="scss">

</style>
